/* tslint:disable */
/* eslint-disable */
/**
 * Neptune Leaderboard REST API
 * Public REST API
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: contact@neptune.ml
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { SeriesValuesRequestSearchAfter } from './SeriesValuesRequestSearchAfter';
import {
    SeriesValuesRequestSearchAfterFromJSON,
    SeriesValuesRequestSearchAfterFromJSONTyped,
    SeriesValuesRequestSearchAfterToJSON,
} from './SeriesValuesRequestSearchAfter';
import type { SeriesValuesDTO } from './SeriesValuesDTO';
import {
    SeriesValuesDTOFromJSON,
    SeriesValuesDTOFromJSONTyped,
    SeriesValuesDTOToJSON,
} from './SeriesValuesDTO';

/**
 * 
 * @export
 * @interface SingleSeriesValuesResponseDTO
 */
export interface SingleSeriesValuesResponseDTO {
    /**
     * 
     * @type {string}
     * @memberof SingleSeriesValuesResponseDTO
     */
    requestId: string;
    /**
     * 
     * @type {SeriesValuesRequestSearchAfter}
     * @memberof SingleSeriesValuesResponseDTO
     */
    searchAfter?: SeriesValuesRequestSearchAfter;
    /**
     * 
     * @type {SeriesValuesDTO}
     * @memberof SingleSeriesValuesResponseDTO
     */
    series?: SeriesValuesDTO;
    /**
     * 
     * @type {SeriesValuesDTO}
     * @memberof SingleSeriesValuesResponseDTO
     */
    stringSeries?: SeriesValuesDTO;
}

/**
 * Check if a given object implements the SingleSeriesValuesResponseDTO interface.
 */
export function instanceOfSingleSeriesValuesResponseDTO(value: object): value is SingleSeriesValuesResponseDTO {
    if (!('requestId' in value) || value['requestId'] === undefined) return false;
    return true;
}

export function SingleSeriesValuesResponseDTOFromJSON(json: any): SingleSeriesValuesResponseDTO {
    return SingleSeriesValuesResponseDTOFromJSONTyped(json, false);
}

export function SingleSeriesValuesResponseDTOFromJSONTyped(json: any, ignoreDiscriminator: boolean): SingleSeriesValuesResponseDTO {
    if (json == null) {
        return json;
    }
    return {
        
        'requestId': json['requestId'],
        'searchAfter': json['searchAfter'] == null ? undefined : SeriesValuesRequestSearchAfterFromJSON(json['searchAfter']),
        'series': json['series'] == null ? undefined : SeriesValuesDTOFromJSON(json['series']),
        'stringSeries': json['stringSeries'] == null ? undefined : SeriesValuesDTOFromJSON(json['stringSeries']),
    };
}

export function SingleSeriesValuesResponseDTOToJSON(value?: SingleSeriesValuesResponseDTO | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'requestId': value['requestId'],
        'searchAfter': SeriesValuesRequestSearchAfterToJSON(value['searchAfter']),
        'series': SeriesValuesDTOToJSON(value['series']),
        'stringSeries': SeriesValuesDTOToJSON(value['stringSeries']),
    };
}

